<template>
  <v-content class="fill-height white">
    <v-container>
      <v-row>
        <v-col cols="4">
          <v-container>
            <v-row>
              <v-col class="text-center">
                <div class="d-flex justify-center">
                  <v-avatar
                    color="white"
                    size="130"
                    :class="[
                      'mx-0',
                      'd-flex',
                      'justify-center',
                      { 'primary': !curriculum.informacion_personal.profile_image }
                    ]"
                    :style="curriculum.informacion_personal.profile_image
                      ? `background: url(${host}${curriculum.informacion_personal.profile_image}); background-size: cover`
                      : ''"
                  >
                    <span
                      v-if="!curriculum.informacion_personal.profile_image"
                      class="white--text display-1 font-weight-bold"
                    >{{initials}}</span>
                  </v-avatar>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <p class="text-center headline font-weight-bold">{{ fullName }}</p>
              </v-col>
            </v-row>
            <v-row v-if="curriculum.informacion_personal.estado_civil || age">
              <v-col class="pb-0">
                <span class>
                  <v-icon small class="mr-1">mdi-account-outline</v-icon>
                  <span v-if="age">{{ age }} años, </span> <span v-if="curriculum.informacion_personal.estado_civil">{{ curriculum.informacion_personal.estado_civil }}</span>
                </span>
              </v-col>
            </v-row>
            <v-row v-if="curriculum.informacion_personal.numero_documento">
              <v-col class="pb-0">
                <v-icon small class="mr-1">mdi-account-details-outline</v-icon>
                <span class>{{ curriculum.informacion_personal.numero_documento }}</span>
              </v-col>
            </v-row>
            <v-row v-if="curriculum.informacion_contacto && curriculum.informacion_contacto.correo">
              <v-col class="pb-0">
                <v-icon small class="mr-1">mdi-email-outline</v-icon>
                <span class>{{ curriculum.informacion_contacto.correo }}</span>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col class="pb-0">
                <v-icon small class="mr-1">mdi-email-outline</v-icon>
                <span class>{{ curriculum.correo }}</span>
              </v-col>
            </v-row>
            <v-row v-if="curriculum.informacion_contacto && curriculum.informacion_contacto.correo">
              <v-col class="pb-0">
                <span class>
                  <v-icon small class="mr-1">mdi-map-marker-outline</v-icon>
                  {{ fullLocation }}
                </span>
              </v-col>
            </v-row>
            <v-row v-if="curriculum.informacion_contacto && curriculum.informacion_contacto.celular">
              <v-col class="pb-0">
                <span class>
                  <v-icon small class="mr-1">mdi-cellphone-android</v-icon>
                  {{ curriculum.informacion_contacto.celular }}
                </span>
              </v-col>
            </v-row>
            <v-row v-if="curriculum.informacion_contacto && curriculum.informacion_contacto.telefono">
              <v-col class="pb-0">
                <span class>
                  <v-icon small class="mr-1">mdi-phone</v-icon>
                  {{ curriculum.informacion_contacto.telefono }}
                </span>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
        <v-col>
          <v-container>
            <!-- Objetivo laboral -->
            <v-row class="mb-4" v-if="curriculum.objetivo_laborals && curriculum.objetivo_laborals.objetivo">
              <v-col>
                <p class="headline font-weight-bold">Objetivo Laboral</p>
                <p>{{ curriculum.objetivo_laborals.objetivo }}</p>
              </v-col>
            </v-row>
            <!-- Experiencia laboral -->
            <v-row v-if="curriculum.experiencia_laborales && curriculum.experiencia_laborales.length">
              <v-col class="headline font-weight-bold">Experiencia Laboral</v-col>
            </v-row>
            <div v-if="curriculum.experiencia_laborales && curriculum.experiencia_laborales.length">
              <div
                v-for="(experienciaLaboral, index) of curriculum.experiencia_laborales"
                :key="index"
              >
                <v-row class="mb-1">
                  <v-col
                    cols="6"
                    class="title font-weight-light pb-0"
                  >{{ experienciaLaboral.puesto }} {{ experienciaLaboral.nivel_experiencia }}</v-col>
                  <v-col cols="6" class="headline font-weight-bold d-flex justify-end pb-0">
                    <v-chip
                      class="px-4 primary--text"
                      color="deep-orange lighten-5"
                    >{{ experienciaLaboral.area_puesto }} - {{ experienciaLaboral.subarea_puesto }}</v-chip>
                  </v-col>
                  <v-col class="caption font-weight-bold py-1 grey--text">
                    <v-icon small class="mr-1" color="grey">mdi-office-building</v-icon>
                    {{ experienciaLaboral.nombre_empresa }}
                  </v-col>
                  <v-col class="caption font-weight-bold d-flex justify-end py-1 grey--text">
                    <v-icon small class="mr-1" color="grey">mdi-clock-outline</v-icon>
                    {{ getStartDateAndEndDateFormat(experienciaLaboral.fecha_inicio, experienciaLaboral.fecha_fin) }}
                    <!-- Abril 12, 2020 - Presente -->
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
              </div>
            </div>
            <!-- Referencias -->
            <v-row class="mt-8" v-if="curriculum.referencias && curriculum.referencias.length">
              <v-col class="headline font-weight-bold">Referencias</v-col>
            </v-row>
            <div class="mt-8" v-if="curriculum.referencias && curriculum.referencias.length">
              <div v-for="(referencia, index) of curriculum.referencias" :key="index">
                <v-row class="mb-1">
                  <v-col
                    cols="6"
                    class="title font-weight-light pb-0"
                  >{{ referencia.nombres }} {{ referencia.apellidos }}</v-col>
                  <v-col cols="6" class="headline font-weight-bold d-flex justify-end pb-0">
                    <v-chip
                      class="px-4 primary--text"
                      color="deep-orange lighten-5"
                    >{{ referencia.relacion }}</v-chip>
                  </v-col>
                  <v-col class="caption font-weight-bold py-1 grey--text">
                    <v-icon small class="mr-1" color="grey">mdi-email-outline</v-icon>
                    {{ referencia.correo }}
                  </v-col>
                  <v-col class="caption font-weight-bold d-flex justify-end py-1 grey--text">
                    <v-icon small class="mr-1" color="grey">mdi-phone-outline</v-icon>
                    {{ referencia.telefono }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
              </div>
            </div>
            <!-- Estudios -->
            <v-row class="mt-8" v-if="curriculum.educacion && curriculum.educacion.length">
              <v-col class="headline font-weight-bold">Estudios</v-col>
            </v-row>
            <div v-if="curriculum.educacion && curriculum.educacion.length">
              <div v-for="(educacion, index) of curriculum.educacion" :key="index">
                <v-row class="mb-1">
                  <v-col
                    cols="6"
                    class="title font-weight-light pb-0"
                  >{{ educacion.titulo_carrera }}</v-col>
                  <v-col cols="6" class="headline font-weight-bold d-flex justify-end pb-0">
                    <v-chip
                      class="px-4 primary--text"
                      color="deep-orange lighten-5"
                    >{{ educacion.estado }}</v-chip>
                  </v-col>
                  <v-col class="caption font-weight-bold py-1 grey--text">
                    <v-icon small class="mr-1" color="grey">mdi-domain</v-icon>
                    {{ educacion.institucion }}
                  </v-col>
                  <v-col class="caption font-weight-bold d-flex justify-end py-1 grey--text">
                    <v-icon small class="mr-1" color="grey">mdi-clock-outline</v-icon>
                    {{ getStartDateAndEndDateFormat(educacion.fecha_inicio, educacion.fecha_fin) }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-divider></v-divider>
                  </v-col>
                </v-row>
              </div>
            </div>
            <!-- Idiomas -->
            <v-row class="mt-8" v-if="curriculum.idiomas && curriculum.idiomas.length">
              <v-col class="headline font-weight-bold">Idiomas</v-col>
            </v-row>
            <div v-if="curriculum.idiomas && curriculum.idiomas.length">
              <v-row>
                <v-col
                  v-for="(idioma, index) of curriculum.idiomas"
                  :key="index"
                  cols="6"
                  class="subtitle font-weight-light pb-0"
                >
                  <div>{{ idioma.idioma }}</div>
                  <v-container class="pt-0 caption grey--text">
                    <v-row>
                      <v-col class="d-flex pb-1 pt-0">
                        Oral
                        <v-spacer></v-spacer>
                        <v-icon
                          small
                          v-for="(language, languageIndex) of languageLevels"
                          :key="languageIndex"
                          class="mr-2"
                          :color="getLevel(idioma.nivel_oral, 'language') >= languageIndex ? 'primary' : 'grey lighten-2'"
                        >mdi-checkbox-blank-circle</v-icon>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="d-flex pt-0">
                        Escrito
                        <v-spacer></v-spacer>
                        <v-icon
                          small
                          v-for="(language, languageIndex) of languageLevels"
                          :key="languageIndex"
                          class="mr-2"
                          :color="getLevel(idioma.nivel_escrito, 'language') >= languageIndex ? 'primary' : 'grey lighten-2'"
                        >mdi-checkbox-blank-circle</v-icon>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-col>
              </v-row>
            </div>
            <!-- Habilidades -->
            <v-row class="mt-8" v-if="curriculum.habilidades && curriculum.habilidades.length">
              <v-col class="headline font-weight-bold">Habilidades</v-col>
            </v-row>
            <div v-if="curriculum.habilidades && curriculum.habilidades.length">
              <v-row>
                <v-col
                  v-for="(habilidad, index) of curriculum.habilidades"
                  :key="index"
                  cols="6"
                  class="subtitle font-weight-light pb-0 d-flex"
                >
                  {{ habilidad.habilidad }}
                  <v-spacer></v-spacer>
                  <v-icon
                    small
                    v-for="(skill, skillIndex) of skillLevels"
                    :key="skillIndex"
                    class="mr-2"
                    :color="getLevel(habilidad.nivel) >= skillIndex ? 'primary' : 'grey lighten-2'"
                  >mdi-checkbox-blank-circle</v-icon>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import config from '@/config';

export default {
  props: {
    curriculum: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      languageLevels: ["Básico", "Intermedio", "Avanzado", "Nativo"],
      skillLevels: ["Básico", "Intermedio", "Avanzado", "Experto"],
      host: config.host,
    };
  },
  computed: {
    initials() {
      const nombresUsuario = this.curriculum.informacion_personal.nombres.split(
        ""
      );
      const apellidosUsuario = this.curriculum.informacion_personal.apellidos.split(
        ""
      );
      return `${nombresUsuario[0].toUpperCase()}${apellidosUsuario[0].toUpperCase()}`;
    },
    fullName() {
      return `${this.curriculum.informacion_personal.nombres} ${this.curriculum.informacion_personal.apellidos}`;
    },
    fullLocation() {
      if (this.curriculum.informacion_contacto
        && this.curriculum.informacion_contacto.direccion
        && this.curriculum.informacion_contacto.provincia
        && this.curriculum.informacion_contacto.pais
        && this.curriculum.informacion_contacto.ciudad) {
          return `${this.curriculum.informacion_contacto.direccion}, ${this.curriculum.informacion_contacto.provincia}, ${this.curriculum.informacion_contacto.ciudad}, ${this.curriculum.informacion_contacto.pais}`;
        }
      return '';
    },
    age() {
      if (!this.curriculum.informacion_personal.fecha_nacimiento) return '';
      return this.$moment().diff(
        this.curriculum.informacion_personal.fecha_nacimiento,
        "years"
      );
    }
  },
  methods: {
    getStartDateAndEndDateFormat(startDate, endDate) {
      const startDateFormat = this.$moment(startDate).format("MMMM DD. YYYY");
      const endDateFormat = endDate
        ? this.$moment(endDate).format("MMMM DD. YYYY")
        : "Presente";
      return `${startDateFormat} - ${endDateFormat}`;
    },
    getLevel(level, type) {
      return type === "language"
        ? this.languageLevels.findIndex(
            languageLevel => languageLevel === level
          )
        : this.skillLevels.findIndex(skillLevel => skillLevel === level);
    },
  }
}
</script>

<style>

</style>